/* Needle to Wax motion: "Quiet". Usage on any wrapper:
   <div data-quiet data-quiet-rise="h2,.deck" data-quiet-fade="p,.btn" data-quiet-soft=".logo">
   rise = headings that slide up line by line; fade = smaller pieces that fade up; soft = fade with a light blur. */
(function(){
  var reduce=false;try{reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
  function splitLines(el){
    if(el.dataset.nqSplit||el.children.length)return false; /* only plain-text headings */
    el.dataset.nqSplit=1;
    var words=el.textContent.trim().split(/\s+/);
    el.innerHTML=words.map(function(w){return '<span class="nq-w">'+w+'</span>';}).join(' ');
    var lines=[],cur=null,top=null;
    el.querySelectorAll('.nq-w').forEach(function(w){var t=w.offsetTop;if(t!==top){cur=[];lines.push(cur);top=t;}cur.push(w.textContent);});
    el.innerHTML=lines.map(function(l,i){return '<span class="nq-ln"><span style="--nq-d:'+i+'">'+l.join(' ')+'</span></span>';}).join('');
    return true;
  }
  function run(){
    var roots=document.querySelectorAll('[data-quiet]');if(!roots.length)return;
    if(!document.querySelector('.nq-grain')){var g=document.createElement('div');g.className='nq-grain';g.setAttribute('aria-hidden','true');document.body.appendChild(g);}
    if(reduce||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('nq-pre');io.unobserve(e.target);}});},{rootMargin:'0px 0px -12% 0px'});
    roots.forEach(function(root){
      var rise=root.dataset.quietRise,fade=root.dataset.quietFade,soft=root.dataset.quietSoft;
      if(rise)root.querySelectorAll(rise).forEach(function(el){if(splitLines(el)){el.classList.add('nq-pre');io.observe(el);}});
      if(fade)root.querySelectorAll(fade).forEach(function(el){el.classList.add('nq-fade','nq-pre');io.observe(el);});
      if(soft)root.querySelectorAll(soft).forEach(function(el){el.classList.add('nq-fade','nq-soft','nq-pre');io.observe(el);});
      /* stagger pieces that share a parent, e.g. text and link inside one step */
      root.querySelectorAll('.nq-fade').forEach(function(el){var sib=[].filter.call(el.parentNode.children,function(c){return c.classList.contains('nq-fade');});var i=sib.indexOf(el);if(i>0)el.style.setProperty('--nq-d',i);});
    });
  }
  var go=function(){(document.fonts&&document.fonts.ready?document.fonts.ready:Promise.resolve()).then(run,run);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
